import Slide from '@/mixins/Slide'
import Keyboard from '@/pure/Keyboard'

export default
{
    mixins: [
        Slide
    ],

    props:
    {
        isOpen: {
            type: Boolean,
            default: false
        },
        layer: {
            type: String,
            default: 'rgba(0,0,0,0.54)'
        },
        background: {
            type: String,
            default: '#42a5f5'
        },
        color: {
            type: String,
            default: '#FFF'
        },
        closeEnabled: {
            type: Boolean,
            default: true
        }
    },

    mounted()
    {
        if (this.closeEnabled)
        {
            this.keyboard = new Keyboard()
            this.keyboard.onUp('Escape', this.close)
        }
    },

    destroyed()
    {
        if (this.keyboard)
        {
            this.keyboard.offUp('Escape', this.close)
            this.keyboard.dispose()
        }
    },

    methods:
    {
        close()
        {
            this.$emit('close')
        }
    }
}
